module.exports = __webpack_public_path__ + "img/ISS Enterprise logo.3b046249.jpg";